import React from 'react';
import { useTranslation } from 'react-i18next';
import '../../../../assets/stylesheets/Dialogs/BetYourHand.scss';
import parameters from "../../../../config/parameters";
import OddItem from "./OddItem";

const BetYourHand = ({type}) => {
  const { t } = useTranslation();
    return (
        <div className="oddsList">
          <div className="oddsListCaption">
            <span className="combs">{t('betYourHand.combinations')}</span>
            <span className="amount">{t('betYourHand.amount')}</span>
            <span className="max">{t('betYourHand.max')}</span>
          </div>
          <div className="oddsListItems">
            {
              parameters.odds[type].map(oddItem => <OddItem oddItem={oddItem}></OddItem>)
            }
          </div>
        </div>
    );
};

export default BetYourHand;
